export enum MemberAssignmentStatus {
  SCHEDULED = "Scheduled",
  СHECKED_IN = "Сhecked In",
  MISSED = "Missed",
  COMPLETED = "Completed",
}
